'use strict';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||!1;descriptor.configurable=!0;if('value'in descriptor)descriptor.writable=!0;Object.defineProperty(target,descriptor.key,descriptor)}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor}}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called')}return call&&(typeof call=='object'||typeof call=='function')?call:self}function _inherits(subClass,superClass){if(typeof superClass!='function'&&superClass!==null){throw new TypeError('Super expression must either be null or a function, not '+typeof superClass)}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass}

const _=require('pulsar-utils/dist-es6/_');
const tryGet=require('pulsar-utils/dist-es6/extensions/tryGet');
const treeUtils=require('pulsar-utils/dist-es6/treeUtils');
const getTextWidth=require('../../../../../dist-es6/client/utilities/getTextWidth');
const Formatters=require('../../../../../dist-es6/client/formatters');
const SortExtensions=require('../../../../../dist-es6/client/extensions/sortExtensions');
const PersonStatisticsViewModel=require('../../../../../dist-es6/client/viewModels/personStatisticsViewModel');
const HeatmapGroupViewModel=require('../../../../../dist-es6/client/viewModels/heatmapGroupViewModel');
const PseudoGroup=require('../../../../../dist-es6/client/domain/pseudoGroup');
const BaseControllerBackedDirective=require('../../../../../dist-es6/client/angularCommon/baseControllerBackedDirective');


const DirectGroupHeaderHeight=35;
const SubGroupHeaderHeight=17;
const DefaultDirectGroupMargin=10;
const DefaultPersonHeight=21;
const MinPersonHeight=6;
const DefaultPersonWidth=160;
const MinPersonWidth=6;
const DefaultPersonAreaPaddingTop=5;
const TopLevelGroupHorizontalPadding=8;
const DefaultPersonHorizontalSpacing=6;
const DefaultPersonVerticalSpacing=6;
const BreadcrumbsHeight=40;
const TooltipWidth=186;

const MinMacroModePersonHeight=1;
const MinMacroModeGroupHeight=4;

const TopLevelHeaderFont='normal normal normal normal 18px "Roboto"';
const SubHeaderFont='normal normal normal normal 12px "Roboto"';
const PersonFont='normal normal normal normal 12px "Roboto"';

const MinimumTopLevelWidthToDisplayLargeNames=getTextWidth('MMM',TopLevelHeaderFont);
const MinimumSubHeadWidthToDisplayNames=getTextWidth('M',SubHeaderFont);
const MinimumPersonWidthToDisplayNames=getTextWidth('MM',PersonFont);
const MinimumPersonHeightToDisplayNames=10;let

DashboardHeatmapDirective=function(_BaseControllerBacked){_inherits(DashboardHeatmapDirective,_BaseControllerBacked);function DashboardHeatmapDirective(){_classCallCheck(this,DashboardHeatmapDirective);return _possibleConstructorReturn(this,_BaseControllerBacked.apply(this,arguments))}_createClass(DashboardHeatmapDirective,[{key:'objectBindings',get:function()
{
return[
'dashboardDataService',
'searchQuery',
'filteredPersons',
'sortByFatigueScore',
'sortByFatigueAlertType',
'groupTree',
'selectedGroupData',
'selectedNotificationType'];

}},{key:'templateUrl',get:function()

{
return'/templates/features/dashboard/components/dashboardHeatmapView';
}},{key:'controller',get:function()

{
return DashboardHeatmapController;
}}]);return DashboardHeatmapDirective}(BaseControllerBackedDirective);let



DashboardHeatmapController=function(){_createClass(DashboardHeatmapController,null,[{key:'$inject',get:function()
{
return['$element','$scope','$timeout','elementService','heatmapService','displaySettingsService','groupTreeService'];
}}]);

function DashboardHeatmapController($element,$scope,$timeout,elementService,heatmapService,displaySettingsService,groupTreeService){var _this2=this;_classCallCheck(this,DashboardHeatmapController);
this._$element=$element;
this._$scope=$scope;
this._$timeout=$timeout;
this._elementService=elementService;
this._heatmapService=heatmapService;
this._displaySettingsService=displaySettingsService;
this._groupTreeService=groupTreeService;

this._heatmapViewModel=null;
this._previousSelectedGroup=null;

this.isInitiallyLoading=!0;
this.groupHoverState=null;

this.useShortTopLevelNames=!1;
this.useShortGroupNames=!1;
this.useShortPersonNames=!1;
this.hidePersonNames=!1;
this.shrinkTopLevelNames=!1;

this.isMacroMode=!1;
this.isUsingFilteredPersons=!1;
this.macroModeGroupInfo=[];

this._personUnitWidth=DefaultPersonWidth;
this._singlePersonStyle={width:DefaultPersonWidth,height:DefaultPersonHeight};
this._heatmapDimensions={};

this.breadcrumbs=[];

this._$scope.$on('resize::resize',function(){return _this2._recalculateDimensions()});

$scope.$watch('controller.selectedGroupData',function(newGroup,oldGroup){
if(_.exists(newGroup)&&newGroup===oldGroup){
return;
}
_this2._updateHeatmapViewModel();
});
$scope.$watch('controller.selectedNotificationType',function(newType,oldType){
if(_.exists(newType)&&newType===oldType){
return;
}
_this2._updateGroupThresholdStatusBars();
});
$scope.$watch('controller.filteredPersons',function(newFilteredPersons,oldFilteredPersons){
if(!_.exists(newFilteredPersons)||newFilteredPersons===oldFilteredPersons){
return;
}
_this2._filteredPersonIds=_.map(newFilteredPersons,'id');
_this2._$timeout(function(){

_this2._recalculateDimensions();
});
});

this.sortByDecendingFatigueAlertTypeAndScore=[
SortExtensions(this.sortByFatigueAlertType).invert(),
SortExtensions(this.sortByFatigueScore).invert(),
'name'];


this._$timeout(function(){

_this2._updateHeatmapViewModel();
});
}DashboardHeatmapController.prototype.

selectSourceGroupById=function selectSourceGroupById(id){
if(id===void 0||id===this.selectedGroupData.id){
return;
}

this._groupTreeService.selectGroupWithId(id);
};DashboardHeatmapController.prototype.

_updateBreadcrumbs=function _updateBreadcrumbs(){
if(this._lastBreadcrumbSelectedGroup===this.selectedGroupData&&this._lastBreadcrumbOrgVM===this._orgHeatmapViewModel){
return;
}
this.breadcrumbs=this._heatmapService.getGroupBreadcrumbs(this.selectedGroupData,this._orgHeatmapViewModel);
this._lastBreadcrumbSelectedGroup=this.selectedGroupData;
this._lastBreadcrumbOrgVM=this._orgHeatmapViewModel;
};DashboardHeatmapController.prototype.

getPersonThresholdClasses=function getPersonThresholdClasses(person){
return Formatters.classFromThresholdStatus(person.thresholdStatusFor(this.selectedNotificationType));
};DashboardHeatmapController.prototype.

getThresholdClassString=function getThresholdClassString(person){
const classes=this.getPersonThresholdClasses(person);
let useClasses=[];
for(const className of _.keys(classes)){
if(classes[className]){useClasses.push(className)}
}

return useClasses.join(' ');
};DashboardHeatmapController.prototype.

getPersonClasses=function getPersonClasses(person){
return _.assign({
found:_.exists(this._filteredPersonIds)&&
this._filteredPersonIds.length!==this._orgHeatmapViewModel.aggregatePersons.length?
this._filteredPersonIds.length>0&&this._filteredPersonIds.includes(person.id):!0},

this.getPersonThresholdClasses(person));
};DashboardHeatmapController.prototype.

getFatigueScore=function getFatigueScore(person){
return Formatters.formatFatigue(_.get(person,'lastKnownStatus.fatigue'));
};DashboardHeatmapController.prototype.

_updateHeatmapViewModel=function _updateHeatmapViewModel(){var _this3=this;
if(!_.exists(this.selectedGroupData)||this.selectedGroupData===this._previousSelectedGroup){
return;
}
this._previousSelectedGroup=this.selectedGroupData;

let group=this.selectedGroupData;

if(!_.exists(this._orgHeatmapViewModel)||this._orgHeatmapViewModelFetchTime!==this._lastFetchTime){

const[[orgGroup],children]=_.partition(this.groupTree,function(g){return g.id===null});
this._orgHeatmapViewModel=HeatmapGroupViewModel.cloneFromGroupStatisticsViewModel(orgGroup);
this._orgHeatmapViewModel.children=children;
this._orgHeatmapViewModelFetchTime=this._lastFetchTime;
this._memoizedViewModelBuilder=_.memoize(function(g){return _this3._heatmapService.constructHeatmapViewModelTree(g)});
}

if(this.selectedGroupData.id===null){
group=this._orgHeatmapViewModel;
}

this._heatmapViewModel=this._memoizedViewModelBuilder(group);

this._directGroups=_.sortBy(this._heatmapViewModel.children.length>0?
this._heatmapViewModel.children:
[this._heatmapViewModel],function(g){return g instanceof PseudoGroup?0:g.name});

this._recalculateDimensions();
};DashboardHeatmapController.prototype.













_recalculateDimensions=function _recalculateDimensions(){var _this4=this;
this._$timeout(function(){
const{width:moduleWidth,height:moduleHeight}=_this4._fleetModuleElement[0].getBoundingClientRect();
const{height:moduleHeaderHeight}=_this4._moduleHeaderElement[0].getBoundingClientRect();
const breadcrumbsHeight=_this4.selectedGroupData.id===null?0:BreadcrumbsHeight;

_this4._updateHeatmapDimensions(moduleWidth,moduleHeight-moduleHeaderHeight-breadcrumbsHeight);
_this4._updatePersonAreaHeight();
_this4._updatePersonAndGroupDimensions();
_this4._updateBreadcrumbs();

if(_this4._personsTilesAreVisible){
_this4._updateNameVisibility();
}else{
_this4._updateGroupThresholdStatusBars();
}

_this4.isInitiallyLoading=!1;
});
};DashboardHeatmapController.prototype.

_updateHeatmapDimensions=function _updateHeatmapDimensions(width,height){
if(this._heatmapDimensions&&
this._heatmapDimensions.width===width&&
this._heatmapDimensions.height===height){
return;
}

this._heatmapDimensions={width:width,height:height};
this.heatmapDimensionsAsCSS=_jsonStyleToCss(this._heatmapDimensions);
};DashboardHeatmapController.prototype.

_updatePersonAreaHeight=function _updatePersonAreaHeight(){
const maxAvailableDepth=this._heatmapService.getMaxAvailableDepth(this._heatmapViewModel);
const headerHeight=maxAvailableDepth===2?
DirectGroupHeaderHeight+SubGroupHeaderHeight:
DirectGroupHeaderHeight;

const newPersonAreaHeight=this._heatmapDimensions.height-headerHeight-DefaultPersonAreaPaddingTop;
if(newPersonAreaHeight===this._personAreaHeight){
return;
}

this._personAreaHeight=newPersonAreaHeight;
};DashboardHeatmapController.prototype.

_updatePersonNameVisibility=function _updatePersonNameVisibility(longestPersonName,_ref){let{height:height,width:width}=_ref;
this.hidePersonNames=width<MinimumPersonWidthToDisplayNames||height<MinimumPersonHeightToDisplayNames;
this.useShortPersonNames=this.hidePersonNames===!1&&
_.exists(longestPersonName)&&
getTextWidth(_replaceWithFixedChar(longestPersonName),PersonFont)>=width;
};DashboardHeatmapController.prototype.

_updateGroupNameVisibility=function _updateGroupNameVisibility(personWidth){
let subGroupsShortDetermined=!1;
let topLevelShrinkDetermined=!1;
let topLevelShortDetermined=!1;
for(const topLevelChild of this._heatmapViewModel.children){
if(topLevelShrinkDetermined&&
subGroupsShortDetermined)break;

let numColSpans=0;
for(const subGroup of topLevelChild.children){
const subGroupColSpans=subGroup.colSpan||1;
numColSpans+=subGroupColSpans;

if(subGroup instanceof PseudoGroup)continue;

const colSpanWidth=subGroupColSpans*personWidth;
if(!subGroupsShortDetermined&&
colSpanWidth<getTextWidth(_replaceWithFixedChar(subGroup.name),SubHeaderFont)){
subGroupsShortDetermined=!0;
}
}

if(topLevelShrinkDetermined)continue;

const realColSpans=_.max([numColSpans,topLevelChild.colSpan])||1;
const topLevelAvailableWidth=realColSpans*personWidth+(realColSpans-1)*DefaultPersonHorizontalSpacing;
if(topLevelAvailableWidth<MinimumTopLevelWidthToDisplayLargeNames){
topLevelShortDetermined=!0;
topLevelShrinkDetermined=!0;
}else if(!topLevelShortDetermined&&
topLevelAvailableWidth<getTextWidth(topLevelChild.name,TopLevelHeaderFont)){
topLevelShortDetermined=!0;
}
}

this.shrinkTopLevelNames=topLevelShrinkDetermined;
this.useShortGroupNames=subGroupsShortDetermined;
this.useShortTopLevelNames=topLevelShortDetermined;
};DashboardHeatmapController.prototype.

_updateNameVisibility=function _updateNameVisibility(){
const namesByDepth=this._heatmapService.getLongestNamesByDepth(this._heatmapViewModel);

this._updatePersonNameVisibility(namesByDepth.person,this._singlePersonStyle);
this._updateGroupNameVisibility(this._singlePersonStyle.width);
};DashboardHeatmapController.prototype.

_getPersonHeight=function _getPersonHeight(){
if(this.personAreaHeight<MinPersonHeight){
return{personHeight:void 0,personVerticalSpacing:void 0};
}

let personHeight=DefaultPersonHeight;
let personVerticalSpacing=DefaultPersonVerticalSpacing;

while(this.personAreaHeight<personHeight){
personVerticalSpacing=personVerticalSpacing/2;
personHeight=personHeight/2;
}

return{personHeight:personHeight,personVerticalSpacing:personVerticalSpacing};
};DashboardHeatmapController.prototype.

_updatePersonAndGroupDimensions=function _updatePersonAndGroupDimensions(){
const{personHeight:personHeight,personVerticalSpacing:personVerticalSpacing}=this._getPersonHeight();

const personHeightWithMargin=personHeight+personVerticalSpacing;
if(!_.exists(personHeight)||personHeightWithMargin>this.personAreaHeight){
_warnNotEnoughSpace(this.personAreaHeight,personHeightWithMargin);
this.isUsingFilteredPersons=!1;
this.isMacroMode=!0;
return;
}

const{leafColSpans:leafColSpans,filteredLeafColSpans:filteredLeafColSpans}=this._heatmapService.determineColSpansForLeafGroups(this._heatmapViewModel,
personHeightWithMargin,
this.personAreaHeight,
this._filteredPersonIds);

const numLeafColumns=leafColSpans.reduce(function(sum,n){return sum+(n||1)},0);
const numFilteredLeafColumns=filteredLeafColSpans.reduce(function(sum,n){return sum+(n||1)},0);

const marginBetweenGroupColumns=DefaultDirectGroupMargin;
const personHorizontalSpacing=DefaultPersonHorizontalSpacing;

const numTopLevelGroups=this._heatmapViewModel.children.length||1;

const totalTopLevelGroupHorizontalPaddingWidth=numTopLevelGroups*(TopLevelGroupHorizontalPadding*2-personHorizontalSpacing);

const totalGroupMarginWidth=(numTopLevelGroups-1)*marginBetweenGroupColumns;
const availableHeatmapWidth=this._heatmapDimensions.width-totalGroupMarginWidth-totalTopLevelGroupHorizontalPaddingWidth;

const personUnitWidth=Math.min(availableHeatmapWidth/numLeafColumns,DefaultPersonWidth);
const personWidthUnfiltered=personUnitWidth-personHorizontalSpacing;

const personUnitWidthFiltered=Math.min(availableHeatmapWidth/numFilteredLeafColumns,DefaultPersonWidth);
const personWidthFiltered=personUnitWidthFiltered-personHorizontalSpacing;

let personWidth;
if(personWidthUnfiltered>=MinPersonWidth){
personWidth=personWidthUnfiltered;
this._personUnitWidth=personUnitWidth;
this._heatmapService.setColSpansForLeafGroups(this._heatmapViewModel,leafColSpans);

this.isUsingFilteredPersons=!1;
this.isMacroMode=!1;
}else if(personWidthUnfiltered!=personWidthFiltered&&personWidthFiltered>=MinPersonWidth){
personWidth=personWidthFiltered;
this._personUnitWidth=personUnitWidthFiltered;
this._heatmapService.setColSpansForLeafGroups(this._heatmapViewModel,filteredLeafColSpans);

this.isUsingFilteredPersons=!0;
this.isMacroMode=!0;
}else{
this.isUsingFilteredPersons=!1;
this.isMacroMode=!0;
return;
}

const newTooltipLeftMargin=personWidth/2-TooltipWidth/2;
if(newTooltipLeftMargin!==this.tooltipLeftMargin){
this.tooltipLeftMargin=newTooltipLeftMargin;
}

const newPersonStyle={width:personWidth};
if(personHeight!==DefaultPersonHeight){
newPersonStyle.height=personHeight;
}







if(personVerticalSpacing!==DefaultPersonVerticalSpacing){
newPersonStyle.marginBottom=personVerticalSpacing;
}

if(_.isEqual(newPersonStyle,this._singlePersonStyle)){
return;
}

this._singlePersonStyle=newPersonStyle;
this.singlePersonCSS=_jsonStyleToCss(newPersonStyle);
};DashboardHeatmapController.prototype.

getMacroModeStatusHeightsFor=function getMacroModeStatusHeightsFor(group){var _this5=this;
const persons=group.aggregatePersons||group.directPersons;
const{
At=[],
Above=[]}=
_.groupBy(persons,function(p){return p.thresholdStatusFor(_this5.selectedNotificationType,p).value});

const personUnitHeight=this.heatmapDimensions.height/this._heatmapService.getMaxNumPersonsInLeafGroups(this._heatmapViewModel);

const numRest=persons.length-Above.length-At.length;
const statusHeights={
above:Above.length*personUnitHeight,
at:At.length*personUnitHeight,
below:numRest*personUnitHeight};


if(personUnitHeight<MinMacroModePersonHeight){
if(statusHeights.above>0&&statusHeights.above<MinMacroModePersonHeight){
statusHeights.above=MinMacroModePersonHeight;
}
if(statusHeights.at>0&&statusHeights.at<MinMacroModePersonHeight){
statusHeights.at=MinMacroModePersonHeight;
}
}

const totalBarsHeight=statusHeights.above+statusHeights.at+statusHeights.below;
if(totalBarsHeight>this.heatmapDimensions.height){
statusHeights.below=this.heatmapDimensions.height-(statusHeights.above+statusHeights.at);
}else if(totalBarsHeight<MinMacroModeGroupHeight){
const atHasHeight=statusHeights.at>0;
const aboveHasHeight=statusHeights.above>0;
const belowHasHeight=statusHeights.below>0;

const numBarsWithHeight=_.compact([atHasHeight,aboveHasHeight,belowHasHeight]).length;
const extraPixelsToDistribute=(MinMacroModeGroupHeight-totalBarsHeight)/numBarsWithHeight;

statusHeights.at+=atHasHeight?extraPixelsToDistribute:0;
statusHeights.above+=aboveHasHeight?extraPixelsToDistribute:0;
statusHeights.below+=belowHasHeight?extraPixelsToDistribute:0;
}

return statusHeights;
};DashboardHeatmapController.prototype.

_updateGroupThresholdStatusBars=function _updateGroupThresholdStatusBars(){var _this6=this;
if(this.isMacroMode===!1){
return;
}

const leafGroups=this._heatmapService.getLeafGroups(this.heatmapViewModel);

this.macroModeGroupInfo=leafGroups.map(function(group){
const{at:at,above:above,below:below}=_this6.getMacroModeStatusHeightsFor(group);

return{
id:group.id,
name:group.name,
parentGroupName:group.parentGroupName,
parentGroupId:group.parentGroupId,
statusBarStyles:{
at:{height:at},
above:{height:above},
below:{height:below}}};


}).reverse();
};DashboardHeatmapController.prototype.

getWidthForCols=function getWidthForCols(numCols){
return this._personUnitWidth*numCols;
};DashboardHeatmapController.prototype.

getPersonPlaceholderDisplayName=function getPersonPlaceholderDisplayName(){
return this.useShortPersonNames===!0?'--':'Empty';
};DashboardHeatmapController.prototype.

getDisplayNameFor=function getDisplayNameFor(personOrGroup){let isTopLevel=arguments.length>1&&arguments[1]!==void 0?arguments[1]:!1;
let useShort;
if(personOrGroup instanceof PersonStatisticsViewModel){
useShort=this.useShortPersonNames;
}else if(isTopLevel===!0){
useShort=this.useShortTopLevelNames;
}else{
useShort=this.useShortGroupNames;
}

return useShort===!0?Formatters.heatmapShortName(personOrGroup):personOrGroup.name;
};_createClass(DashboardHeatmapController,[{key:'_personsTilesAreVisible',get:function(){return!this.isMacroMode||this.isUsingFilteredPersons&&this.isMacroMode}},{key:'_fleetModuleElement',get:function(){return this.__fleetModuleElement||(this.__fleetModuleElement=this._elementService.selectElement('.fleet-module'))}},{key:'_moduleHeaderElement',get:function(){return this.__moduleHeaderElement||(this.__moduleHeaderElement=this._fleetModuleElement.find('.module-header'))}},{key:'heatmapViewModel',get:function()

{
return this._heatmapViewModel;
}},{key:'personAreaHeight',get:function()

{
return this._personAreaHeight;
}},{key:'heatmapDimensions',get:function()

{
return this._heatmapDimensions;
}},{key:'singlePersonStyle',get:function()

{
return this._singlePersonStyle;
}},{key:'directGroups',get:function()

{
return this._directGroups;
}},{key:'_lastFetchTime',get:function()

{
return tryGet(this,'dashboardDataService.lastFetchTime').
then(function(t){return t.getTime()}).
otherwise(null);
}}]);return DashboardHeatmapController}();


function _replaceWithFixedChar(str){
return'M'+str.replace(/[a-z]/g,'e');
}

const _jsonStyleToCss=function(styleObj){return JSON.stringify(styleObj).replace(/,/g,'px;').replace(/[{}"]+/g,'')+'px'};

function _warnNotEnoughSpace(areaHeight,personHeightWithMargin){
console.warn(`Not enough space to draw people... bailing! PersonAreaHeight: ${areaHeight}, PersonHeightWithMargin: ${personHeightWithMargin}`);
}

module.exports=DashboardHeatmapDirective;
//# sourceMappingURL=dashboardHeatmapDirective.js.map
